var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1258_16609)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_16609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0158 33.9756C41.02 37.2893 38.3371 39.979 35.0234 39.9832L9.02346 40.0164C5.70976 40.0206 3.02005 37.3377 3.01583 34.024L2.9827 8.02402C2.97848 4.71031 5.66135 2.0206 8.97506 2.01638L34.975 1.98326C38.2887 1.97904 40.9785 4.66191 40.9827 7.97561L41.0158 33.9756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0158 33.9756C41.02 37.2893 38.3371 39.979 35.0234 39.9832L9.02346 40.0164C5.70976 40.0206 3.02005 37.3377 3.01583 34.024L2.9827 8.02402C2.97848 4.71031 5.66135 2.0206 8.97506 2.01638L34.975 1.98326C38.2887 1.97904 40.9785 4.66191 40.9827 7.97561L41.0158 33.9756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2984 25.71C18.9074 25.32 18.9066 24.6868 19.2966 24.2958L22.5853 20.9987L19.2882 17.71C18.8972 17.32 18.8964 16.6868 19.2864 16.2958C19.6764 15.9048 20.3096 15.9039 20.7006 16.294L24.7057 20.2889C25.0967 20.6789 25.0975 21.3121 24.7075 21.7031L20.7126 25.7082C20.3226 26.0992 19.6894 26.1 19.2984 25.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0222 38.9832L9.02219 39.0164L9.02474 41.0163L35.0247 40.9832L35.0222 38.9832ZM4.01583 34.0227L3.9827 8.02275L1.98271 8.02529L2.01583 34.0253L4.01583 34.0227ZM8.97633 3.01638L34.9763 2.98326L34.9738 0.983262L8.97378 1.01638L8.97633 3.01638ZM39.9827 7.97689L40.0158 33.9769L42.0158 33.9743L41.9827 7.97434L39.9827 7.97689ZM34.9763 2.98326C37.7377 2.97974 39.9792 5.21546 39.9827 7.97689L41.9827 7.97434C41.9777 4.10835 38.8398 0.978337 34.9738 0.983262L34.9763 2.98326ZM3.9827 8.02275C3.97919 5.26132 6.21491 3.0199 8.97633 3.01638L8.97378 1.01638C5.10779 1.02131 1.97778 4.1593 1.98271 8.02529L3.9827 8.02275ZM9.02219 39.0164C6.26077 39.0199 4.01934 36.7841 4.01583 34.0227L2.01583 34.0253C2.02075 37.8913 5.15875 41.0213 9.02474 41.0163L9.02219 39.0164ZM35.0247 40.9832C38.8907 40.9783 42.0207 37.8403 42.0158 33.9743L40.0158 33.9769C40.0193 36.7383 37.7836 38.9797 35.0222 38.9832L35.0247 40.9832Z",
    fill: "#D1D5DB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.0222 38.9832L9.02219 39.0164L9.02474 41.0163L35.0247 40.9832L35.0222 38.9832ZM4.01583 34.0227L3.9827 8.02275L1.98271 8.02529L2.01583 34.0253L4.01583 34.0227ZM8.97633 3.01638L34.9763 2.98326L34.9738 0.983262L8.97378 1.01638L8.97633 3.01638ZM39.9827 7.97689L40.0158 33.9769L42.0158 33.9743L41.9827 7.97434L39.9827 7.97689ZM34.9763 2.98326C37.7377 2.97974 39.9792 5.21546 39.9827 7.97689L41.9827 7.97434C41.9777 4.10835 38.8398 0.978337 34.9738 0.983262L34.9763 2.98326ZM3.9827 8.02275C3.97919 5.26132 6.21491 3.0199 8.97633 3.01638L8.97378 1.01638C5.10779 1.02131 1.97778 4.1593 1.98271 8.02529L3.9827 8.02275ZM9.02219 39.0164C6.26077 39.0199 4.01934 36.7841 4.01583 34.0227L2.01583 34.0253C2.02075 37.8913 5.15875 41.0213 9.02474 41.0163L9.02219 39.0164ZM35.0247 40.9832C38.8907 40.9783 42.0207 37.8403 42.0158 33.9743L40.0158 33.9769C40.0193 36.7383 37.7836 38.9797 35.0222 38.9832L35.0247 40.9832Z",
    fill: "#B26EE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1258_16609",
    x: 0.974609,
    y: 0.975586,
    width: 42.0488,
    height: 42.0483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1258_16609"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1258_16609",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_16609"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0158 33.9756C41.02 37.2893 38.3371 39.979 35.0234 39.9832L9.02346 40.0164C5.70976 40.0206 3.02005 37.3377 3.01583 34.024L2.9827 8.02402C2.97848 4.71031 5.66135 2.0206 8.97506 2.01638L34.975 1.98326C38.2887 1.97904 40.9785 4.66191 40.9827 7.97561L41.0158 33.9756Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRight);
export default __webpack_public_path__ + "static/media/square-right.1ff8adc350f056d34d7814a25cf2e637.svg";
export { ForwardRef as ReactComponent };